import { type SearchRequest } from '@searchkit/api';

import { getTimezoneForRepub } from '~/apps/product-plus/search-domain/constants/timezones';
import { getTrendsSorting, resultAttributes } from '~/apps/product-plus/search-domain/pipelines/trends/query-config';
import { createQueryFactory } from '~/apps/product-plus/search-domain/pipelines/trends/query-factory';
import { type SearchDomainContext } from '~/apps/product-plus/search-domain/types';
import {
  getHitRateBucket,
  normalizeFacetFilters,
  resolveActiveSort,
  withRequestParams,
} from '~/apps/product-plus/search-domain/utils';

export function buildTrendsQuery(context: SearchDomainContext, searchRequest: SearchRequest) {
  const params = searchRequest.request?.params ?? {};
  const facetFilters = normalizeFacetFilters(params.facetFilters);

  const mapSearchRequest: SearchRequest = withRequestParams(searchRequest, {
    facetFilters,
    hitsPerPage: params.hitsPerPage ?? 10,
    page: params.page ?? 0,
  });

  const sorting = getTrendsSorting(context);
  const activeSort = resolveActiveSort(mapSearchRequest.indexName, mapSearchRequest.request.indexName, sorting.options);
  const hitRateBucket = getHitRateBucket(activeSort.field);
  const timezone = getTimezoneForRepub(context.repubConfig.name);

  const last10PersistentSortEnabled = context.searchFlags.last10PersistentSort;

  return createQueryFactory({
    activeSort,
    hitRateBucket,
    last10PersistentSortEnabled,
    resultAttributes,
    searchRequest: mapSearchRequest,
    timezone,
  });
}
